import { readTranslationLocale } from "./locale";
import type { MessageKey } from "./messages/ko";
import { translate, type MessageParams } from "./translate";

/**
 * 컴포넌트 밖에서 문구를 만든다. computed·렌더 안에서 부르면 언어 전환을 따라가고,
 * 이벤트 처리 중에 부르면 그 순간의 로케일로 고정된다.
 */
export function translateCurrent(
  key: MessageKey,
  params?: MessageParams
): string {
  return translate(readTranslationLocale(), key, params);
}
